import { render } from "./ResidentList.vue?vue&type=template&id=62ad1110&scoped=true"
import script from "./ResidentList.vue?vue&type=script&lang=js"
export * from "./ResidentList.vue?vue&type=script&lang=js"

import "./ResidentList.vue?vue&type=style&index=0&id=62ad1110&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ad1110"]])

export default __exports__